import { _ALUMNOS_MAP, SvAlumnoObtenerFotoURL } from "./Alumno";

export enum EPhotoSize {
    NORMAL = 1,
    PREVIEW = 2,
    THUMBNAIL = 3
}

export function _URLChildPhoto(idUsuario: number, sizePhoto: EPhotoSize): string {
    const id = idUsuario + "_" + sizePhoto;

    if (PHOTO_ALUMNO_MAP.has(id))
        return PHOTO_ALUMNO_MAP.get(id);
    else {
        let _url = SvAlumnoObtenerFotoURL(idUsuario, sizePhoto);
        PHOTO_ALUMNO_MAP.set(id, _url);
        return _url;
    }
}

const PHOTO_ALUMNO_MAP: Map<string, string> = new Map();

export function _SetURLPhoto(idUsuario: number) {
    const idThumb = idUsuario + "_" + EPhotoSize.THUMBNAIL;
    const _url = SvAlumnoObtenerFotoURL(idUsuario, EPhotoSize.THUMBNAIL) + "&TEMP=" + Date.now();

    PHOTO_ALUMNO_MAP.set(idThumb, _url);

    const idNorm = idUsuario + "_" + EPhotoSize.NORMAL;
    if (PHOTO_ALUMNO_MAP.has(idNorm)) {
        const _urlNorm = SvAlumnoObtenerFotoURL(idUsuario, EPhotoSize.NORMAL) + "&TEMP=" + Date.now();
        PHOTO_ALUMNO_MAP.set(idNorm, _urlNorm);
    }

    const idPrev = idUsuario + "_" + EPhotoSize.PREVIEW;
    if (PHOTO_ALUMNO_MAP.has(idPrev)) {
        const _urlPrev = SvAlumnoObtenerFotoURL(idUsuario, EPhotoSize.PREVIEW) + "&TEMP=" + Date.now();
        PHOTO_ALUMNO_MAP.set(idPrev, _urlPrev);
    }
}

export function _UpdateURLChildPhoto(idChild: number) {
    const objChild = _ALUMNOS_MAP.get(idChild);
    if (objChild) {
        _SetURLPhoto(objChild.IdUsuario);
        const id = objChild.IdUsuario + "_" + EPhotoSize.THUMBNAIL;
        objChild.urlPhoto = PHOTO_ALUMNO_MAP.get(id);
    }
}